/**
 * https://docs.infiniteajaxscroll.com/getting-started
 * https://github.com/webcreate/infinite-ajax-scroll
 */

import InfiniteAjaxScroll from '@webcreate/infinite-ajax-scroll';
import textClamp from "../../js/modules/textClamp.js";
import {init_basket} from "../cart/basket.js";
import catalogPhoto from "../catalog/catalogPhoto.js";

function pagination() {
    window.pagination = ({subClassId, disableBlockMarkup, disableBlockListMarkup, paginationAllValue, nextLink, curPos2, numberOfPages}) => {
    // function pagination({subClassId, disableBlockMarkup, disableBlockListMarkup, paginationAllValue, nextLink, curPos2, numberOfPages}) {

        const blockMarkupClass = (disableBlockMarkup || disableBlockListMarkup) || (disableBlockMarkup === undefined && disableBlockListMarkup === undefined) ? "" : " > .tpl-block-list-objects";

        const ias = new InfiniteAjaxScroll(`.infoblock-id-${subClassId} .pagination-ajax-wrapper ${blockMarkupClass}`, {
            item: `.infoblock-id-${subClassId} .pagination-ajax-wrapper ${blockMarkupClass} > *:not(.pagination-ajax-item-excluded)`,
            next: `.infoblock-id-${subClassId} .next`,
            pagination: `.infoblock-id-${subClassId} .pagination-ajax`,
            spinner: `.infoblock-id-${subClassId} .pagination-ajax-loader`,
            logger: false,
            trigger: paginationAllValue === 'pagination_click' && (nextLink || curPos2 < numberOfPages - 1) ? `.infoblock-id-${subClassId} .button-container-pagination-ajax .button2` : false,
        });

        ias.on('appended', function (event) {
            // lazyLoadInstance.update();

            if (typeof (init_basket) === "function") {
                init_basket();
            }

            if (typeof (textClamp) === "function") {
                textClamp();
            }

            if (typeof (catalogPhoto) === "function") {
                catalogPhoto();
            }

            // Инициализация кнопок «Положить в корзину» модуля "Интернет-магазин" (раскомментировать при использовании модуля "Интернет-магазин")
            // if (document.querySelectorAll('.tpl-link-cart-add').length) {
            //     document.querySelectorAll('.tpl-link-cart-add').forEach(elem => {
            //         const form = elem.closest('form');
            //
            //         showLoader();
            //
            //         fetch(`${form.getAttribute('action')}?json=1`, {
            //             method: 'POST',
            //             body: new FormData(form)
            //         })
            //             .then(response => response.json())
            //             .then(processCartResponse)
            //             .catch(processCartError);
            //
            //         // $.post(form.attr('action'), form.serialize() + "&json=1", null, 'json')
            //         //     .done(function(response) { processCartResponse(response); })
            //         //     .fail(processCartError);
            //         return false;
            //     });
            // }
        });

        /* На последней странице удаляем div с пагинацией, чтоб она не мешала стилям */
        ias.on('last', function () {
            // document.querySelector(`.infoblock-id-${subClassId} .pagination-ajax-container`).classList.add("mb-minus"); // На последней странице добавляем класс для нормальных отступов ячеек
            document.querySelector(`.infoblock-id-${subClassId} .pagination-ajax-container`).remove();
        })

        /* Обновление урла и тайтла при пагинации */
        // ias.on('page', (event) => {
        //     // update the title
        //     document.title = event.title;
        //
        //     // update the url
        //     let state = history.state;
        //     history.replaceState(state, event.title, event.url);
        // });
    }
}

export default pagination;